<template>
    <!-- Feature Section start -->
    <section id="feature" class="feature">
        <div class="feature-decor">
            <div class="feature-circle1">
                <img :src="require('../assets/images/feature2.png')" alt="" />
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="feature-phone">
                    <img :src="require('../assets/images/features/mac.png')" class="laptop small-screen" alt="" />
                </div>
                <div class="offset-lg-4 col-lg-8">
                    <div class="row">
                        <div class="col-sm-12 mrgn-md-top">
                            <h2 class="title">features of the<span> Xtreme RMS</span></h2>
                        </div>
                        <div class="col-12 col-md-6">
                            <ul class="feature-style">
                                <!-- <li>
                  <div class="feature-icon">
                    <img
                      :src="require('../assets/images/icon/1.png')"
                      alt="icon"
                    />
                  </div>
                  <div class="feature-subtitle">
                    <h3>user friendly</h3>
                  </div>
                  <div>
                    <p>
                      Our programs are designed to be end user friendly from the
                      go. No need for multiple training sessions or confusion.
                    </p>
                  </div>
                </li> -->
                                <li>
                                    <div class="feature-icon">
                                        <img :src="require('../assets/images/icon/3.png')" alt="icon" />
                                    </div>
                                    <div class="feature-subtitle">
                                        <h3>Maximize your AV uptime</h3>
                                    </div>
                                    <div>
                                        <p>
                                            We offer, live monitoring of your AV systems. If something goes wrong, most of the time we know about it before you.
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <div class="feature-icon">
                                        <img :src="require('../assets/images/icon/4.png')" alt="icon" />
                                    </div>
                                    <div class="feature-subtitle">
                                        <h3>Secure</h3>
                                    </div>
                                    <div>
                                        <p>
                                            We pride ourselves on security employing the latest in security protocols and encryption techniques.
                                        </p>
                                    </div>
                                </li>
                                <!-- <li>
                  <div class="feature-icon">
                    <img
                      :src="require('../assets/images/icon/5.png')"
                      alt="icon"
                    />
                  </div>
                  <div class="feature-subtitle">
                    <h3>unlimited features</h3>
                  </div>
                  <div>
                    <p>
                      You never hear us say, "it cannot be done" with time,
                      patience and investment we can acheive anything you need
                      to the highest of standards.
                    </p>
                  </div>
                </li> -->
                            </ul>
                        </div>
                        <div class="col-12 col-md-6 sm-m-top">
                            <ul class="feature-style">
                                <li>
                                    <div class="feature-icon">
                                        <img :src="require('../assets/images/icon/2.png')" alt="icon" />
                                    </div>
                                    <div class="feature-subtitle">
                                        <h3>quick update</h3>
                                    </div>
                                    <div>
                                        <p>
                                            Remote update & help to maintain even the most complex installs at speed.
                                        </p>
                                    </div>
                                </li>
                                <li class="small-screen">
                                    <div class="feature-icon">
                                        <img :src="require('../assets/images/icon/6.png')" alt="icon" />
                                    </div>
                                    <div class="feature-subtitle">
                                        <h3>24 x 7 support</h3>
                                    </div>
                                    <div>
                                        <p>
                                            We can offer 24/7 support on your projects with our RMS and international staff.
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Feature Section End -->
</template>
<script>
export default {
    name: "feature"
}
</script>
<style>
.laptop {
    position: relative;
    left: -10%;
    top: 125px;
    height: 400px !important;
    height: 425px !important;
}

@media (min-width: 1367px) and (max-width: 1669px) {
    .feature-phone img {
        width: 50%;
    }
}

@media (max-width: 1366px) {
    .feature-phone img {
        width: 50%;
    }
}

@media screen and (min-width: 1680px) {
    .laptop {
        left: -30%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/feature.vue